module.exports = __webpack_public_path__ + "img/adee3498516c518d736455d254e54a28.jpg";